/*
    公共类
*/

import {get} from '@/api/common/index'

// 获取枚举
/*
    枚举名称	对应申请字段
    EnumSex	性别
    EnumCertType	证件类型
    EnumMaritalStatus	婚姻状况
    EnumRentType	租赁方式
    EnumAreaType	面积计算方式
    EnumBuildingPropertyType	产权性质
    EnumCityHousingType	房屋类型
*/
const getEnumList = (typeName) => {
    return get("/api/common/get_enum_list", {typeName: typeName})
}

// 获取系统参数（SysCodeInfo）
/*
    参数代号	对应申请字段
    Education	学历
    Title	职称
    Profession	职业
    IdentityType	户口性质
    PoliticalStatus	政治面貌
    StreetTownList	区镇
    Nation	民族
*/
const getSysCodeList = (type) => {
    return get("/api/common/get_syscode_info", {type: type})
}

const getCompanyList = ()=>{
    return get("/api/common/get_company_list");
}

export default {
    getEnumList,
    getSysCodeList,
    getCompanyList
}